import React, { Component, PropTypes } from 'react';
import ComponentTitle from './ComponentTitle';
import classNames from 'classnames';
import { checkIOSDevice } from '../../utils/DOMUtils';
import { TITLE_TYPE } from '../../constants/FRNBaseStyles';
import { getCurrentWindowBreakpointSize } from '../../utils/WindowUtils';

class IFrame extends Component {
  static propTypes = {
    title: PropTypes.string,
    url: PropTypes.string.isRequired,
    dimensionsPerBreakpoint: PropTypes.object,
    showBorder: PropTypes.bool,
    borderColor: PropTypes.string,
    enableFullScreen: PropTypes.bool,
    sandbox: PropTypes.string,
    titleType: PropTypes.string,
    showScrollBar: PropTypes.bool
  }

  static defaultProps = {
    showBorder: false,
    showScrollBar: false,
    enableFullscreen: false,
    borderColor: '',
    titleType: TITLE_TYPE.MODULE_TITLE
  }

  state = {
    width: null,
    hieght: null
  }

  componentDidMount() {
    this._updateIFrameDimensions();

    window.addEventListener('resize', () => this._updateIFrameDimensions());
  }

  componentWillUnmount() {
    window.removeEventListener('resize', () => this._updateIFrameDimensions());
  }

  _updateIFrameDimensions() {
    const { dimensionsPerBreakpoint = {} } = this.props;
    const currentWindowBreakpointSize = getCurrentWindowBreakpointSize();
    let height;
    let width;

    if (dimensionsPerBreakpoint[currentWindowBreakpointSize]) {
      width = dimensionsPerBreakpoint[currentWindowBreakpointSize].width;
      height = dimensionsPerBreakpoint[currentWindowBreakpointSize].height;
    }

    this.setState({
      width,
      height
    });
  }

  render() {
    const {
      title,
      url,
      showBorder,
      borderColor,
      enableFullScreen,
      sandbox,
      titleType,
      showScrollBar
    } = this.props;

    const { width, height } = this.state;

    let iframeStyles = {
      width: width ? `${width}px` : null,
      height: height ? `${height}px` : null
    };
    /**
     * Because the iframe isn't responsive in ios browsers
     * issue https://stackoverflow.com/questions/23083462/how-to-get-an-iframe-to-be-responsive-in-ios-safari#answer-23083463
     */
    const isIOSDevice = checkIOSDevice();
    const iframeClassName = classNames('embed-responsive-item', 'IFrame-item', { 'IFrame-item--iOS': isIOSDevice });
    let scrolling = showScrollBar ? 'yes' : 'no';

    if (isIOSDevice && scrolling === 'yes') {
      iframeStyles['overflow'] = 'auto';
      iframeStyles['-webkit-overflow-scrolling'] = 'touch';  

      scrolling = 'no';
    }

    return (
      <div className="IFrame">
        {title ? <ComponentTitle titleType={titleType} title={title} /> : null}
        <div className={`embed-responsive ${!height ? 'embed-responsive-16by9' : ''}`} style={iframeStyles}>
          <iframe className={iframeClassName}
            scrolling={scrolling}
            src={url}
            allowFullScreen={enableFullScreen}
            sandbox={sandbox ? sandbox : null}
            style={{border: showBorder ? ('1px solid ' + borderColor) : 'none'}}
          />
        </div>
      </div>
    );
  }
}

export default IFrame;



// WEBPACK FOOTER //
// ./app/components/shared/IFrame.js